import { SignUp } from '@clerk/react';

export default function Join() {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', marginTop: '60px' }}>
      {/* 
          1. 'path' must match your React Router route.
          2. 'routing="path"' tells Clerk to use the URL for state (like verification).
      */}
      <SignUp 
        path="/join" 
        routing="path" 
        signInUrl="/login"
        afterSignUpUrl="/" 
      />
    </div>
  );
}